<template>
    <!-- -----------------------------------------------
          Start Footer
    ----------------------------------------------- -->
    <v-footer class="footer px-0">
      <v-container>
        <v-row class="py-6 py-sm-7">
          <!-- -----------------------------------------------
          First Column - About
        ----------------------------------------------- -->
          <v-col cols="12" md="3" sm="6" class="px-xs-0">
            <h4 class="font-weight-medium mb-5 text-h6">About Contigen</h4>
            <p class="mt-5 text-muted">Contigen is an AI-powered platform that helps content creators, marketers, and businesses create, optimize, and distribute high-quality blog content more efficiently.</p>
            <div class="social-icons mt-5">
              <NuxtLink to="https://www.facebook.com/contigenai">
                <i class="mdi mdi-facebook"></i>
              </NuxtLink>
              <NuxtLink to="https://www.twitter.com/contigenai">
                <i class="mdi mdi-twitter"></i>
              </NuxtLink>
              <NuxtLink to="https://www.youtube.com/contigenai">
                <i class="mdi mdi-youtube"></i>
              </NuxtLink>
              <NuxtLink to="https://www.instagram.com/contigenai">
                <i class="mdi mdi-instagram"></i>
              </NuxtLink>
              <NuxtLink to="https://www.linkedin.com/company/contigenai">
                <i class="mdi mdi-linkedin"></i>
              </NuxtLink>
            </div>
          </v-col>
          
          <!-- -----------------------------------------------
          Second Column - Quick Links
        ----------------------------------------------- -->
          <v-col cols="12" md="3" sm="6" class="px-xs-0">
            <h4 class="font-weight-medium mb-5 text-h6">Quick Links</h4>
            <ul class="list-unstyled">
              <li class="mb-3">
                <NuxtLink to="/features/content-creation" class="text-muted text-decoration-none">Features</NuxtLink>
              </li>
              <li class="mb-3">
                <NuxtLink to="/pricing" class="text-muted text-decoration-none">Pricing</NuxtLink>
              </li>
              <li class="mb-3">
                <NuxtLink to="/resources/blog" class="text-muted text-decoration-none">Blog</NuxtLink>
              </li>
              <li class="mb-3">
                <NuxtLink to="/contact" class="text-muted text-decoration-none">Contact</NuxtLink>
              </li>
            </ul>
          </v-col>
          
          <!-- -----------------------------------------------
          Third Column - Newsletter
        ----------------------------------------------- -->
          <v-col cols="12" md="3" sm="6" class="px-xs-0">
            <h4 class="font-weight-medium mb-5 text-h6">Newsletter</h4>
            <p class="mt-5 text-muted">Subscribe to our newsletter for the latest updates, tips, and special offers.</p>
            <div class="mt-5">
              <v-form>
                <v-text-field
                  label="Email Address"
                  variant="outlined"
                  density="compact"
                  hide-details
                  class="mb-3"
                ></v-text-field>
                <v-btn color="primary" block>Subscribe</v-btn>
              </v-form>
            </div>
          </v-col>
          
          <!-- -----------------------------------------------
          Fourth Column - Contact
        ----------------------------------------------- -->
          <v-col cols="12" md="3" sm="6" class="px-xs-0">
            <h4 class="font-weight-medium mb-5 text-h6">Contact</h4>
            <p class="mt-5 text-muted">15169 N Scottsdale Road Suite 205, Scottsdale, AZ, 85254</p>
            <p class="mt-3 text-muted">
              Support: <NuxtLink class="text-dark text-decoration-none" to="mailto:support@contigenai.com">support@contigenai.com</NuxtLink>
            </p>
          </v-col>
        </v-row>
        <div class="footer-bottom-bar mt-sm-5 mt-0 font-14 ml-sm-0 ml-n3">
          <div class="d-block d-sm-flex align-center">
            <p class="text-muted mb-sm-0 mb-3">
              &copy; 2025 Contigen. All Rights Reserved.
            </p>
            <div class="ml-auto">
              <div class="d-sm-flex align-center">
                <NuxtLink to="/legal/terms-of-service" class="text-muted text-decoration-none px-sm-4 ps-0">Terms of Service</NuxtLink>
                <NuxtLink to="/legal/privacy-policy" class="text-muted text-decoration-none px-sm-4 px-2">Privacy Policy</NuxtLink>
                <NuxtLink to="/sitemap" class="text-muted text-decoration-none px-sm-4 px-2">Sitemap</NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </v-container>
    </v-footer>
    <!-- -----------------------------------------------
          End Footer
    ----------------------------------------------- -->
  </template>